import { all, call, put, select, takeEvery } from "redux-saga/effects";

import { ApiManager } from "services/api";
import {
  deserialize,
  deserializeList,
  deserializeLiveChatImport,
  deserializeLiveChatImportDiff,
  deserializeLiveChatSelectiveImport,
  deserializeLiveChatSelectiveImportStart,
  deserializeLivechatGroups,
} from "services/api/integrations/integrations-serializer";
import { IActionWithPayload } from "store/helper";

import { CRUDAction, RequestAction } from "../actions";
import { LicenseActions } from "../license";

import { INTEGRATION, IntegrationsActions } from "./actions";
import {
  IFetchSinglePayload,
  IFetchSingleSuccessPayload,
  IIntegration,
  ILiveChatImportStartPayload,
  ILiveChatImportStatus,
  ILiveChatSelectiveImportStartPayload,
} from "./interfaces";
import { selectLiveChatIntegration } from "./selectors";

function importIsFinished(importStatus: ILiveChatImportStatus): boolean {
  return importStatus.status === "complete" || importStatus.status === "failed";
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* fetchSingle(action: IActionWithPayload<string, IFetchSinglePayload>) {
  const { id } = action.payload;
  const { result, error } = yield call(ApiManager.integrationsApi.fetch, id);

  if (result) {
    const value = deserialize(result);
    const requestData = { liveChatImportFinished: false };
    const liveChatIntegration: IIntegration = yield select(selectLiveChatIntegration);
    if (
      liveChatIntegration &&
      liveChatIntegration.id === id &&
      (!liveChatIntegration.import || !importIsFinished(liveChatIntegration.import)) &&
      value.import &&
      importIsFinished(value.import)
    ) {
      requestData.liveChatImportFinished = true;
    }
    yield put(IntegrationsActions.fetchSuccess({ id, value, requestData }));
  } else {
    yield put(IntegrationsActions.fetchFailure({ id, error: error.message }));
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* fetchSingleSuccess(action: IActionWithPayload<string, IFetchSingleSuccessPayload>) {
  const { value, requestData } = action.payload;
  if (requestData && requestData.liveChatImportFinished === true) {
    yield put(
      IntegrationsActions.liveChatImportFinished({
        // @ts-expect-error TS(2532): Object is possibly 'undefined'.
        success: value.import.status === "complete",
      })
    );
  }
  yield put(LicenseActions.fetchLivechatProperties());
  yield put(IntegrationsActions.fetchLivechatGroups());
  yield put(IntegrationsActions.fetchLiveChatImportDiff());
  yield put(IntegrationsActions.fetchLiveChatSelectiveImport());
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* fetchCollection() {
  const { result, error } = yield call(ApiManager.integrationsApi.fetchAll);

  if (result) {
    yield put(
      IntegrationsActions.fetchCollectionSuccess({
        values: deserializeList(result),
      })
    );
  } else {
    yield put(IntegrationsActions.fetchCollectionFailure({ error: error.message }));
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* fetchLiveChatImport() {
  const { result, error } = yield call(ApiManager.integrationsApi.fetchLiveChatImport);

  if (result) {
    yield put(
      IntegrationsActions.fetchLiveChatImportSuccess({
        // @ts-expect-error TS(2322): Type 'null' is not assignable to type 'string'.
        id: null,
        value: deserializeLiveChatImport(result),
      })
    );
  } else {
    yield put(IntegrationsActions.fetchLiveChatImportFailure({ error: error.message }));
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* fetchLiveChatSelectiveImport() {
  const { result, error } = yield call(ApiManager.integrationsApi.fetchLiveChatSelectiveImport);

  if (result) {
    yield put(
      IntegrationsActions.fetchLiveChatSelectiveImportSuccess({
        // @ts-expect-error TS(2322): Type 'null' is not assignable to type 'string'.
        id: null,
        value: deserializeLiveChatSelectiveImport(result),
      })
    );
  } else {
    yield put(IntegrationsActions.fetchLiveChatSelectiveImportFailure({ error: error.message }));
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* startLiveChatSelectiveImport(
  action: IActionWithPayload<string, ILiveChatSelectiveImportStartPayload>
) {
  const { types } = action.payload;

  const { result, error } = yield call(ApiManager.integrationsApi.startLiveChatSelectiveImport, types);

  if (result) {
    yield put(
      IntegrationsActions.startLiveChatSelectiveImportSuccess({
        // @ts-expect-error TS(2322): Type 'null' is not assignable to type 'string'.
        id: null,
        value: deserializeLiveChatSelectiveImportStart(result, types),
      })
    );
  } else {
    yield put(IntegrationsActions.startLiveChatSelectiveImportFailure({ error: error.message }));
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* fetchLivechatImportDiff() {
  const { result, error } = yield call(ApiManager.integrationsApi.fetchLiveChatImportDiff);

  if (result) {
    yield put(
      IntegrationsActions.fetchLiveChatImportDiffSuccess({
        // @ts-expect-error TS(2322): Type 'null' is not assignable to type 'string'.
        id: null,
        value: deserializeLiveChatImportDiff(result),
      })
    );
  } else {
    yield put(IntegrationsActions.fetchLiveChatImportDiffFailure({ error: error.message }));
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* startLiveChatImport(action: IActionWithPayload<string, ILiveChatImportStartPayload>) {
  const { importDataFrom } = action.payload;

  const { result, error } = yield call(ApiManager.integrationsApi.startLiveChatImport, importDataFrom);
  if (result) {
    yield put(IntegrationsActions.startLiveChatImportSuccess(deserialize(result)));
  } else {
    yield put(IntegrationsActions.startLiveChatImportFailure({ error: error.message }));
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* markLiveChatIntegrationTutorialAsVisited() {
  const liveChatIntegration: IIntegration = yield select(selectLiveChatIntegration);
  if (!liveChatIntegration) {
    yield put(
      IntegrationsActions.markLiveChatIntegrationTutorialAsVisitedFailure({
        error: "LiveChat integration is not installed.",
      })
    );
    return;
  }

  const { result, error } = yield call(ApiManager.integrationsApi.update, liveChatIntegration.id, {
    flags: {
      visitedLiveChatIntegrationTutorial: true,
    },
  });
  if (result) {
    yield put(IntegrationsActions.markLiveChatIntegrationTutorialAsVisitedSuccess({ value: deserialize(result) }));
  } else {
    yield put(IntegrationsActions.markLiveChatIntegrationTutorialAsVisitedFailure({ error: error.message }));
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* fetchLivechatGroups() {
  // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
  const response = yield call(ApiManager.integrationsApi.fetchLivechatGroups);

  if (response.result) {
    yield put(IntegrationsActions.fetchLivechatGroupsSuccess(deserializeLivechatGroups(response.result)));
  } else {
    yield put(IntegrationsActions.fetchLivechatGroupsFailure({ id: "0", error: "failed to fetch groups" }));
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* integrationsSagas() {
  yield all([
    takeEvery(INTEGRATION[CRUDAction.FETCH_SINGLE][RequestAction.REQUEST], fetchSingle),
    takeEvery(INTEGRATION[CRUDAction.FETCH_SINGLE][RequestAction.SUCCESS], fetchSingleSuccess),
    takeEvery(INTEGRATION[CRUDAction.FETCH_COLLECTION][RequestAction.REQUEST], fetchCollection),
    takeEvery(INTEGRATION.LIVECHAT_IMPORT_FETCH[RequestAction.REQUEST], fetchLiveChatImport),
    takeEvery(INTEGRATION.LIVECHAT_SELECTIVE_IMPORT_FETCH[RequestAction.REQUEST], fetchLiveChatSelectiveImport),
    takeEvery(INTEGRATION.LIVECHAT_SELECTIVE_IMPORT_START[RequestAction.REQUEST], startLiveChatSelectiveImport),
    takeEvery(INTEGRATION.LIVECHAT_IMPORT_DIFF[RequestAction.REQUEST], fetchLivechatImportDiff),
    takeEvery(INTEGRATION.LIVECHAT_IMPORT_START[RequestAction.REQUEST], startLiveChatImport),
    takeEvery(
      INTEGRATION.MARK_LIVECHAT_TUTORIAL_AS_VISITED[RequestAction.REQUEST],
      markLiveChatIntegrationTutorialAsVisited
    ),
    takeEvery(INTEGRATION.FETCH_LIVECHAT_GROUPS[RequestAction.REQUEST], fetchLivechatGroups),
  ]);
}
